import React from "react";
import "./DeviceDetails.scss";
import { CheckCircle, OfflineBolt } from "@mui/icons-material";

function DeviceDetails({ selectedUser }) {
  return (
    <div className="user-accounts-tab user-agent-details">
      <div className="accounts-tab-header"> Device Account Details</div>
      {selectedUser == null ? (
        <></>
      ) : (
        <div className="balance-container">
          <div className="accounts-information">
            <div className="account-details">
              <div className="account-info-type">Device Name:</div>
              <div className="account-info-response">
                {selectedUser.Vmerchantpi.businessname}
              </div>
            </div>
            <div className="account-details align-items-center">
              <div className="account-info-type">Agent ID:</div>
              <div className="account-info-response">
                {selectedUser.Vmerchantpi.userid}
              </div>
              {/* <div
            className="pointer add-funds-crm-button"
            onClick={handleOpen}
          >
            Add Funds
          </div> */}
            </div>
            <div className="account-details">
              <div className="account-info-type">Address:</div>
              <div className="account-info-response">
                {selectedUser.Vmerchantpi.businessaddress1},{" "}
                {selectedUser.Vmerchantpi.businesscity},{" "}
                {selectedUser.Vmerchantpi.businessstate},{" "}
                {selectedUser.Vmerchantpi.businesscountry},{" "}
                {selectedUser.Vmerchantpi.businesszipcode},
              </div>
            </div>
            <div className="account-details">
              <div className="account-info-type">Status:</div>
              <div className="account-info-response">
                {" "}
                {selectedUser.Vmerchantpi.allowed === "1" ? (
                  <div>
                    <CheckCircle sx={{ color: "#25d366" }} />
                    <span className="px-2">Online</span>
                  </div>
                ) : (
                  <div>
                    <OfflineBolt sx={{ color: "red" }} />
                    <span className="px-2"> Offline</span>
                  </div>
                )}
              </div>
            </div>
            <div className="account-details">
              <div className="account-info-type">Liquidity:</div>
              <div className="account-info-response">$9625</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeviceDetails;
